import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from "@headlessui/react";
import { useDialog } from "../../hooks/useDialog";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { useEffect } from "react";
import { DialogTypes } from "../../context/DialogProvider";
import { AiOutlineQuestion } from "react-icons/ai";
import { AiOutlineDelete } from "react-icons/ai";

const CommonDialog = () => {
    const { isOpen, openDialog, closeDialog, dialogContent, onConfirm } = useDialog();

    if (!isOpen) return null;

    const handleConfirm = () => {
        if (onConfirm) {
            onConfirm();
        }
        closeDialog();
    };

    const getDialogIcon = (type) => {
        switch (type) {
            case DialogTypes.REQUEST:
                return (
                    <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                        <AiOutlineQuestion className="text-blue-500" />
                    </div>
                );
            case DialogTypes.DELETE:
                return (
                    <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                        <AiOutlineDelete className="text-red-500" />
                    </div>
                );

            default:
                return null;
        }
    };

    return (
        <Dialog open={isOpen} onClose={closeDialog} className="relative z-10">
            <DialogBackdrop
                transition
                className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />

            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                    <DialogPanel
                        transition
                        className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                    >
                        <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                            <div className="sm:flex sm:items-start">
                                {getDialogIcon(dialogContent.type)}
                                <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                                    <DialogTitle as="h3" className="text-base font-semibold leading-6 text-gray-900">
                                        {dialogContent.title}
                                    </DialogTitle>
                                    <div className="mt-2">
                                        <p className="text-sm text-gray-500">{dialogContent.content}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {dialogContent.type === DialogTypes.REQUEST && (
                            <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                <button
                                    type="button"
                                    onClick={handleConfirm}
                                    className="inline-flex w-full justify-center rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 sm:ml-3 sm:w-auto"
                                >
                                    {dialogContent.confirText ?? "확인"}
                                </button>
                                <button
                                    type="button"
                                    data-autofocus
                                    onClick={closeDialog}
                                    className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-500 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                                >
                                    {dialogContent.confirText ?? "취소"}
                                </button>
                            </div>
                        )}
                    </DialogPanel>
                </div>
            </div>
        </Dialog>
    );
};

export default CommonDialog;
